import React from 'react';
import Img from 'gatsby-image';
import { graphql } from 'gatsby';
import { uid } from 'react-uid';
import Tag from '../../Tag';
import P from '../../Paragraph';
import SendGridLink from '../../SendGridLink';
import SectionHeader from '../SectionHeader';
import Section from '../Section';
import { StyledCards, StyledCard, StyledGraphic, StyledMedia } from './styles';

const UseCaseImageCards = ({ block }) => {
  return (
    <Section theme={block.theme}>
      <SectionHeader tagline={block.tagline} title={block.title} />
      <StyledCards>
        {block.cards.map((card) => (
          <StyledCard key={uid(card)}>
            {card.badge && (
              <Tag
                color={card.theme}
                dangerouslySetInnerHTML={{ __html: card.badge }}
              />
            )}
            <StyledMedia key={uid(card.image)}>
              <Img
                fluid={card.image.imageFile.childImageSharp.fluid}
                alt={card.image.altText}
              />
            </StyledMedia>
            <div>
              <h3
                style={{ color: '#4A6592' }}
                dangerouslySetInnerHTML={{ __html: card.title }}
              />
              <div>
                <P dangerouslySetInnerHTML={{ __html: card.copy }} />
                <SendGridLink
                  to={card.ctaUrl}
                  className="arrow-link"
                  dangerouslySetInnerHTML={{ __html: card.ctaText }}
                />
              </div>
            </div>
          </StyledCard>
        ))}
        {block.graphic && block.cards.length % 2 && (
          <StyledGraphic>
            <Img
              alt={block.graphic.altText}
              fluid={block.graphic.imageFile.childImageSharp.fluid}
            />
          </StyledGraphic>
        )}
      </StyledCards>
    </Section>
  );
};

export default UseCaseImageCards;

export const query = graphql`
  fragment UseCaseImageCardsFragment on WPGraphQL_UseCase {
    acfUseCases {
      contentBlocks {
        ... on WPGraphQL_UseCase_Acfusecases_ContentBlocks_ImageCards {
          fieldGroupName
          theme
          tagline
          title
          graphic {
            sourceUrl
            altText
            imageFile {
              childImageSharp {
                fluid(maxWidth: 485) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          cards {
            theme
            title
            badge
            copy
            ctaText
            ctaUrl
            image {
              altText
              sourceUrl
              imageFile {
                childImageSharp {
                  fluid(maxWidth: 485) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
